import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded'
import PrintRoundedIcon from '@mui/icons-material/PrintRounded'
import { Container, Grid, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Label from 'components/Label'
import { TabEducationContent } from 'components/TabTeenager/TabEducationContent'
import { TabFamilyContent } from 'components/TabTeenager/TabFamilyContent'
import { TabHealthContent } from 'components/TabTeenager/TabHealthContent'
import { TabPersonalDataContent } from 'components/TabTeenager/TabPersonalDataContent'
import { TabProfessionalDataContent } from 'components/TabTeenager/TabProfessionalDataContent'
import { TabRelatedProcessesContent } from 'components/TabTeenager/TabRelatedProcessesContent'
import { TabWelcomeContent } from 'components/TabTeenager/TabWelcomeContent'
import Layout from 'layouts/Default'
import {
  StyledBoxCenter as BoxCenter,
  StyledPrintContent,
  StyledSubtitle,
  StyledTitle,
} from 'pages/DownloadTeenager/style'
import React, { LegacyRef, useCallback, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import generatePDF, { Margin } from 'react-to-pdf'
import { useReactToPrint } from 'react-to-print'
import teenagerService from 'services/teenager.service'
import { TeenagerType } from 'types/teenager-record.type'

type GroupItemProps = {
  label: string
  content: React.ReactNode | null
}

type DownloadTeenagerProps = {
  isPrint: boolean
  isExport: boolean
}

const DownloadTeenager: React.FC<DownloadTeenagerProps> = ({ isExport, isPrint }) => {
  const { id } = useParams()

  const [data, setData] = useState<TeenagerType | undefined>(undefined)

  const pageTitle = 'Ficha de Adolescente'
  const componentRef = useRef(null)

  const getPersonalDataSection = (data?: TeenagerType): GroupItemProps => ({
    label: 'DADOS PESSOAIS',
    content:
      data && data.identAdolescente ? (
        <TabPersonalDataContent data={data.identAdolescente} />
      ) : null,
  })

  // const getRelatedProcessSection = (data?: TeenagerType): GroupItemProps => ({
  //   label: 'PROCESSOS RELACIONADOS',
  //   content: data ? <TabRelatedProcessesContent data={data} /> : null,
  // })

  const getHealthSection = (data?: TeenagerType): GroupItemProps => ({
    label: 'DADOS DE SAÚDE',
    content:
      data && data.identAdolescente ? <TabHealthContent data={data.identAdolescente} /> : null,
  })

  const getEducationSection = (data?: TeenagerType): GroupItemProps => ({
    label: 'DADOS DE EDUCAÇÃO',
    content: data ? <TabEducationContent data={data} /> : null,
  })

  const getProfessionalDataSection = (data?: TeenagerType): GroupItemProps => ({
    label: 'DADOS PROFISSIONAIS',
    content:
      data && data.identAdolescente ? (
        <TabProfessionalDataContent data={data.identAdolescente} />
      ) : null,
  })

  const getFamilySection = (data?: TeenagerType): GroupItemProps => ({
    label: 'DADOS DE FAMÍLIA',
    content:
      data && data.identAdolescente ? <TabFamilyContent data={data.identAdolescente} /> : null,
  })

  const getWelcomeSection = (data?: TeenagerType): GroupItemProps => ({
    label: 'DADOS DE ACOLHIMENTO',
    content:
      data && data.identAdolescente ? <TabWelcomeContent data={data.identAdolescente} /> : null,
  })

  const listGroupItems = [
    getPersonalDataSection(data),
    // getRelatedProcessSection(data),
    getHealthSection(data),
    getEducationSection(data),
    getProfessionalDataSection(data),
    getFamilySection(data),
    getWelcomeSection(data),
  ]

  const handlePrint = useReactToPrint({
    content: () => componentRef?.current,
    documentTitle: pageTitle,
  })

  const handleExportAsPDF = async (): Promise<void> => {
    try {
      await generatePDF(componentRef, {
        filename: `ficha-adolescente-${new Date().getTime()}.pdf`,
        page: {
          margin: Margin.MEDIUM,
        },
        canvas: {
          qualityRatio: 1,
        },
      })
    } catch (error) {
      console.error('Error Generating PDF:', error)
    }
  }

  const getTeenagerById = useCallback(async (): Promise<void> => {
    try {
      if (!id) return
      const res = await teenagerService.getById(parseInt(id))
      if (res.data) setData(res.data)
    } catch (err) {
      console.log('General Data Request: ', err)
    }
  }, [id, setData])

  useEffect(() => {
    getTeenagerById()
  }, [getTeenagerById])

  return (
    <Layout>
      <Container>
        <StyledPrintContent ref={componentRef as LegacyRef<HTMLDivElement>}>
          <div className='print__wrapper--outter'>
            <div className='content__wrapper print__wrapper'>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <BoxCenter>
                    <img src='/img/logotipo_MP.png' />
                  </BoxCenter>
                </Grid>
                <Grid item xs={12}>
                  <StyledTitle>
                    <Label text='FICHA ADOLESCENTE' v='h6' bold />
                  </StyledTitle>
                </Grid>
              </Grid>
              {listGroupItems.map((item, index) => (
                <div key={index} className='content__wrapper__segment page-break'>
                  <Stack direction='column' spacing={2}>
                    <StyledSubtitle>
                      <Label text={item.label} v='h6' bold />
                    </StyledSubtitle>
                    {item.content}
                  </Stack>
                </div>
              ))}
            </div>
          </div>
        </StyledPrintContent>
        <Grid container>
          <Grid item xs={12}>
            <BoxCenter>
              {isPrint && (
                <Button
                  variant='contained'
                  color='info'
                  startIcon={<PrintRoundedIcon />}
                  size='large'
                  sx={{ marginRight: '1rem' }}
                  onClick={handlePrint}
                >
                  Imprimir
                </Button>
              )}
              {isExport && (
                <Button
                  variant='contained'
                  color='info'
                  startIcon={<IosShareRoundedIcon />}
                  size='large'
                  onClick={handleExportAsPDF}
                >
                  Exportar
                </Button>
              )}
            </BoxCenter>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  )
}

export default DownloadTeenager
